import React, { useState } from "react";
import { Row, Col, Button } from "antd";
import { ArrowRightOutlined, RocketOutlined, CheckCircleOutlined } from '@ant-design/icons';
import styled from "styled-components";
import Popup from "./popup";

const CTAContainer = styled.div`
  background: linear-gradient(90deg, #000 0%, #FF6600 100%);
  padding: 80px 20px;
  color: white;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="20" cy="20" r="2" fill="rgba(255,255,255,0.1)"/><circle cx="80" cy="40" r="1.5" fill="rgba(255,255,255,0.1)"/><circle cx="40" cy="80" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="90" cy="20" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="10" cy="90" r="1.5" fill="rgba(255,255,255,0.1)"/></svg>');
    animation: float 20s ease-in-out infinite;
  }
  
  @keyframes float {
    0%, 100% { transform: translateY(0px) rotate(0deg); }
    50% { transform: translateY(-20px) rotate(180deg); }
  }
`;

const CTAContent = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  z-index: 1;
`;

const CTATitle = styled.h2`
  font-size: 3rem;
  font-weight: 700;
  color: white;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
`;

const CTASubtitle = styled.p`
  font-size: 1.3rem;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 40px;
  line-height: 1.6;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 40px;
`;

const PrimaryButton = styled(Button)`
  background: #d1bd21;
  color: black;
  border: none;
  height: 60px;
  padding: 0 40px;
  font-size: 1.2rem;
  font-weight: 600;
  border-radius: 30px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  
  &:hover {
    background: #b8a01d;
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  }
`;

const SecondaryButton = styled(Button)`
  background: transparent;
  color: white;
  border: 2px solid white;
  height: 60px;
  padding: 0 40px;
  font-size: 1.2rem;
  font-weight: 600;
  border-radius: 30px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: white;
    color: white;
    transform: translateY(-2px);
  }
`;

const TrustIndicators = styled.div`
  display: flex;
  justify-content: center;
  gap: 40px;
  flex-wrap: wrap;
  margin-top: 40px;
  
  .trust-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 1rem;
    color: rgba(255, 255, 255, 0.9);
  }
`;

const ModernCTASection = () => {
  const [modalVisible, setModalVisible] = useState(false);

  const showModal = () => {
    setModalVisible(true);
  };

  const handleClose = () => {
    setModalVisible(false);
  };

  return (
    <CTAContainer>
      <CTAContent>
        <RocketOutlined style={{ fontSize: '4rem', marginBottom: '20px', opacity: '0.9' }} />
        
        <CTATitle>
          You became a recruiter to find great people — not manage software.
        </CTATitle>

        <CTASubtitle>
          ChronoFlow handles the admin: screening, pipeline updates, scheduling,
          manager handoffs, offer letters. Your job is to choose the right person.
          Everything else is on us.
        </CTASubtitle>
        
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <span style={{ color: 'rgba(255,255,255,0.8)', fontSize: '16px' }}>
            Questions? 
            <span 
              onClick={showModal}
              style={{ 
                color: '#d1bd21', 
                cursor: 'pointer', 
                textDecoration: 'underline',
                marginLeft: '8px',
                fontWeight: '500'
              }}
            >
              Contact our team
            </span>
          </span>
        </div>
        
        <ButtonContainer>
          <PrimaryButton onClick={() => {
            const element = document.getElementById('pricing-cards');
            if (element) element.scrollIntoView({ behavior: 'smooth' });
          }}>
            <RocketOutlined />
            Start Free Trial
          </PrimaryButton>
          
          <SecondaryButton onClick={() => window.location.href = '/job-board'}>
            Browse Jobs
            <ArrowRightOutlined />
          </SecondaryButton>
        </ButtonContainer>
        
        <TrustIndicators>
          <div className="trust-item">
            <CheckCircleOutlined style={{ color: '#FF6600' }} />
            7-Day Free Trial
          </div>
          <div className="trust-item">
            <CheckCircleOutlined style={{ color: '#FF6600' }} />
            No Credit Card Required
          </div>
          <div className="trust-item">
            <CheckCircleOutlined style={{ color: '#FF6600' }} />
            Setup in 15 Minutes
          </div>
          <div className="trust-item">
            <CheckCircleOutlined style={{ color: '#FF6600' }} />
            Cancel Anytime
          </div>
        </TrustIndicators>
      </CTAContent>
      <Popup visible={modalVisible} onClose={handleClose} />
    </CTAContainer>
  );
};

export default ModernCTASection;